import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex p-4 items-center justify-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "p-4 bg-white/10" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = { class: "font-sourcesanspro-semibold text-l2 uppercase" }
const _hoisted_6 = { class: "font-sourcesanspro-regular text-xs uppercase font-color-text-50" }
const _hoisted_7 = { class: "flex justify-end" }
const _hoisted_8 = { class: "font-sourcesanspro-regular text-xs uppercase font-color-text-50" }
const _hoisted_9 = {
  key: 0,
  class: "flex justify-end"
}
const _hoisted_10 = { class: "font-sourcesanspro-regular text-xs uppercase font-color-text-50" }
const _hoisted_11 = { class: "font-sourcesanspro-semibold text-sm2" }
const _hoisted_12 = { class: "font-sourcesanspro-regular text-sm font-color-text-50" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_15 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_16 = { class: "font-sourcesanspro-regular text-sm font-color-text-50" }
const _hoisted_17 = {
  key: 0,
  class: "font-sourcesanspro-semibold text-sm2"
}
const _hoisted_18 = {
  key: 0,
  class: "ml-5"
}
const _hoisted_19 = {
  key: 2,
  class: "mb-2"
}
const _hoisted_20 = { class: "font-sourcesanspro-regular text-sm font-color-text-50" }
const _hoisted_21 = {
  key: 0,
  class: "font-sourcesanspro-semibold text-sm2"
}
const _hoisted_22 = {
  key: 0,
  class: "value tx-value"
}
const _hoisted_23 = { key: 3 }
const _hoisted_24 = { class: "font-sourcesanspro-regular text-sm font-color-text-50" }
const _hoisted_25 = { class: "p-4 bg-white/10" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 0,
  class: "font-sourcesanspro-regular text-sm2 font-color-text-50"
}
const _hoisted_28 = {
  key: 1,
  class: "font-sourcesanspro-regular text-sm2 font-color-text-50"
}
const _hoisted_29 = {
  key: 2,
  class: "font-sourcesanspro-regular text-sm2 font-color-text-50"
}
const _hoisted_30 = {
  key: 3,
  class: "font-sourcesanspro-regular text-sm2 font-color-text-50"
}
const _hoisted_31 = {
  key: 4,
  class: "font-sourcesanspro-regular text-sm2 font-color-text-50"
}
const _hoisted_32 = {
  key: 5,
  class: "font-sourcesanspro-regular text-sm2 font-color-text-50"
}
const _hoisted_33 = {
  key: 6,
  class: "font-sourcesanspro-regular text-sm2 font-color-text-50"
}
const _hoisted_34 = {
  key: 7,
  class: "font-sourcesanspro-regular text-sm2 font-color-text-50"
}
const _hoisted_35 = {
  key: 8,
  class: "font-sourcesanspro-regular text-sm2 font-color-text-50"
}
const _hoisted_36 = {
  key: 9,
  class: "font-sourcesanspro-regular text-sm2 font-color-text-50"
}
const _hoisted_37 = {
  key: 10,
  class: "font-sourcesanspro-semibold text-sm2 text-nowrap"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "flex justify-between" }
const _hoisted_41 = { class: "font-sourcesanspro-regular text-sm2 font-color-text-50" }
const _hoisted_42 = { class: "font-sourcesanspro-semibold text-sm2" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "flex justify-between" }
const _hoisted_46 = { class: "font-sourcesanspro-regular text-sm2 font-color-text-50 font-bold" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "font-sourcesanspro-semibold text-sm2" }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = {
  key: 0,
  class: "font-sourcesanspro-semibold text-sm2"
}
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = {
  key: 2,
  class: "font-sourcesanspro-semibold text-sm2"
}
const _hoisted_55 = {
  key: 2,
  class: "mt-5 p-3 bg-white/5 rounded"
}
const _hoisted_56 = { class: "flex justify-between mb-2" }
const _hoisted_57 = { class: "font-sourcesanspro-semibold text-sm2 text-orange-400" }
const _hoisted_58 = { class: "flex justify-between mb-1" }
const _hoisted_59 = { class: "font-sourcesanspro-regular text-sm font-color-text-50" }
const _hoisted_60 = { class: "font-sourcesanspro-semibold text-sm" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { class: "flex justify-between mb-1" }
const _hoisted_63 = { class: "font-sourcesanspro-regular text-sm font-color-text-50" }
const _hoisted_64 = { class: "font-sourcesanspro-semibold text-sm" }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = {
  key: 0,
  class: "mt-3 pt-3 border-t border-white/10"
}
const _hoisted_67 = { class: "text-xs font-color-text-50 mb-2 uppercase font-sourcesanspro-semibold" }
const _hoisted_68 = { class: "flex items-center" }
const _hoisted_69 = { class: "font-sourcesanspro-regular text-xs font-color-text-50 capitalize" }
const _hoisted_70 = { class: "text-xs font-color-text-50" }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { key: 1 }
const _hoisted_73 = {
  key: 3,
  class: "mt-5 p-3 bg-white/5 rounded"
}
const _hoisted_74 = { class: "flex justify-between mb-2" }
const _hoisted_75 = { class: "font-sourcesanspro-semibold text-sm2 text-orange-400" }
const _hoisted_76 = { class: "flex justify-between mb-1" }
const _hoisted_77 = { class: "font-sourcesanspro-regular text-sm font-color-text-50" }
const _hoisted_78 = { class: "font-sourcesanspro-semibold text-sm" }
const _hoisted_79 = {
  key: 0,
  class: "flex justify-between mb-1"
}
const _hoisted_80 = { class: "font-sourcesanspro-regular text-sm font-color-text-50" }
const _hoisted_81 = { class: "font-sourcesanspro-semibold text-sm text-red-400" }
const _hoisted_82 = { class: "flex justify-between pt-2 border-t border-white/10" }
const _hoisted_83 = { class: "font-sourcesanspro-semibold text-sm2 text-green-400" }
const _hoisted_84 = { class: "font-sourcesanspro-semibold text-sm2 text-green-400" }
const _hoisted_85 = { class: "flex justify-between mt-5" }
const _hoisted_86 = { class: "font-sourcesanspro-regular text-sm2 font-color-text-50" }
const _hoisted_87 = { class: "font-sourcesanspro-semibold text-sm2" }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { key: 1 }
const _hoisted_90 = { key: 4 }
const _hoisted_91 = { class: "font-sourcesanspro-regular text-sm2 font-color-text-50" }
const _hoisted_92 = {
  key: 5,
  class: "flex justify-between"
}
const _hoisted_93 = { class: "font-sourcesanspro-regular text-sm2 font-color-text-50" }
const _hoisted_94 = { class: "font-sourcesanspro-semibold text-sm2 capitalize" }

import { PropType, ref, watch } from 'vue';
import { IonSpinner, loadingController } from '@ionic/vue';
import { useI18n } from 'vue-i18n';

import type { DownloadModalProps } from '@/shared/interfaces/download';
import { DownloadType } from '@/shared/interfaces/download';
import type { TenantConfig } from '@/shared/interfaces/tenant';
import useDownload from '@/shared/composables/useDownload';
import useUtils from '@/shared/composables/useUtils';
import useWallet from '@/modules/wallet/composables/useWallet';
import useCurrencies from '@/shared/composables/useCurrencies';
import { OverviewTransaction } from '@/shared/interfaces/wallet';


export default /*@__PURE__*/_defineComponent({
  __name: 'TransactionOverview',
  props: {
	shouldLoad: { type: Boolean, required: true },
	transactionId: { type: String, required: true },
	encryptedRfidTag: { type: String },
	tenantConfig: { type: Object as PropType<TenantConfig>, required: true },
},
  setup(__props) {

const props = __props;

// Init
const { t } = useI18n();
const { getTransactionDownloadLink, getWalletTransaction } = useWallet();
const { isLoading, shouldLoad, walletTransaction } = getWalletTransaction(props.transactionId, props.encryptedRfidTag);
const { convertToCurrency, groupAndSumTransactionsByCurrency } = useUtils();
const { presentDownloadAvailableModal } = useDownload();
const { fiatCurrency } = useCurrencies();
const walletTransactionTotal = ref();
const walletTransactionTotalFiat = ref();

watch(
	() => walletTransaction.value,
	(newValue) => {
		if (newValue && newValue.overview) {
			if (newValue.transaction.type === 'top_up') {
				// For topups, calculate total by subtracting debit from credit transactions
				const transactions = newValue.overview.transactions || [];
				let creditTotal = 0;
				let debitTotal = 0;

				transactions.forEach((transaction: OverviewTransaction) => {
					if (transaction.type === 'top_up_cost') {
						return;
					}

					const amount = parseFloat(transaction.amount);
					if (transaction.direction === 'CREDIT') {
						creditTotal += amount;
					} else if (transaction.direction === 'DEBIT') {
						debitTotal += amount;
					}
				});

				walletTransactionTotal.value = creditTotal - debitTotal;
				walletTransactionTotalFiat.value = parseFloat(newValue.overview.price);
			} else {
				// Check if this is a split payment
				if (newValue.transaction.is_split_payment) {
					// For split payments, find the RFID/wallet payment amount from the split payment metadata
					let walletAmount = 0;
					if (newValue.transaction.split_payment && newValue.transaction.split_payment.payment_methods) {
						const rfidMethod = newValue.transaction.split_payment.payment_methods.find((method) => method.type === 'rfid' && method.wallet_id === newValue.transaction.wallet_id);
						if (rfidMethod && rfidMethod.amount) {
							walletAmount = parseFloat(rfidMethod.amount);
						}
					}

					// Fallback to transaction amount if we can't find it in metadata
					if (walletAmount === 0) {
						walletAmount = Math.abs(parseFloat(newValue.transaction.amount));
					}

					walletTransactionTotal.value = walletAmount;
					walletTransactionTotalFiat.value = walletAmount * (newValue.transaction.currency?.exchange_rate ?? 1);
				} else {
					// The overview.price is in fiat currency, convert to token currency
					walletTransactionTotal.value = parseFloat(newValue.overview.price) / (newValue.transaction.currency?.exchange_rate ?? 1);
					walletTransactionTotalFiat.value = parseFloat(newValue.overview.price);
				}
			}
		}
	},
	{ immediate: true },
);

const onDownload = async () => {
	const loader = await loadingController.create({
		message: t('general.please_wait'),
	});
	await loader.present();

	const response = await getTransactionDownloadLink(walletTransaction.value!.transaction.id);

	const data: DownloadModalProps = {
		downloadItem: {
			href: response.download_link,
			linkName: t('download_modal.receipt_link_name', { reference: walletTransaction.value!.transaction.reference }),
		},
		title: t('download_modal.title', { file_name: t('download_modal.receipt_link_name', { reference: walletTransaction.value!.transaction.reference }) }),
		downloadType: DownloadType.INVOICE,
	};

	await presentDownloadAvailableModal(data);
	await loader.dismiss();
};

// Helper method to calculate the paid price for a 'top up cost' transaction
const paidTransactionCostPrice = (): number | string => {
	try {
		if (walletTransaction.value!.transaction.price_excl && walletTransaction.value!.transaction.price_vat) {
			return +walletTransaction.value!.transaction.price_excl + +walletTransaction.value!.transaction.price_vat;
		} else {
			return walletTransaction.value!.transaction.amount;
		}
	} catch (e) {
		return walletTransaction.value!.transaction.amount;
	}
};

const isCurrencyPrice = (transactionOverviewItem: any): boolean => {
	return transactionOverviewItem.is_currency_price && transactionOverviewItem.is_currency_price === true;
};

const paymentMethodTranslationKey = (): string => {
	let key = 'undefined';
	const translationKey = 'components.transaction_detail.';

	switch (walletTransaction.value!.transaction.order?.payment_method) {
		case 'ideal':
			key = 'payment_method_ideal';
			break;
		case 'paypal':
			key = 'payment_method_paypal';
			break;
		case 'creditcard':
			key = 'payment_method_credit_card';
			break;
		case 'applepay':
			key = 'payment_method_applepay';
			break;
		case 'bancontact':
			key = 'payment_method_bancontact';
			break;
		case 'voucher':
			key = 'payment_method_voucher';
			break;
		case 'wire_transfer':
			key = 'payment_method_wire_transfer';
			break;
		case 'virtual_wallet_transaction':
			key = 'payment_method_virtual_wallet';
			break;
		case 'virtual_wallet_transaction_order_only':
			key = 'payment_method_virtual_wallet_order_only';
			break;
		case 'virtual_wallet_transaction_free_offer':
			key = 'payment_method_virtual_wallet_free_offer';
			break;
		case 'virtual_wallet_transaction_free_staff':
			key = 'payment_method_virtual_wallet_free_staff';
			break;
		case 'virtual_wallet_transaction_cash_payment':
			key = 'payment_method_virtual_wallet_cash_payment';
			break;
		case 'virtual_wallet_transaction_card_payment':
			key = 'payment_method_virtual_wallet_card_payment';
			break;
		case 'virtual_wallet_split_payment':
			key = 'payment_method_split_payment';
			break;
	}

	return translationKey + key;
};

// Watch props and check if shouldLoad should change the state of the query
// and load data
watch(props, () => {
	if (props.shouldLoad) {
		shouldLoad.value = props.shouldLoad;
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(IonSpinner), { name: "dots" })
        ]))
      : _createCommentVNode("", true),
    (_unref(walletTransaction) && _unref(walletTransaction).overview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(walletTransaction)?.overview.type !== 'topup' ? _unref(t)('transaction_overview.receipt') : _unref(t)('transaction_overview.proof_of_transaction')), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('components.transaction.pos_id')) + " " + _toDisplayString(_unref(walletTransaction)?.transaction.scanned_by_id || _unref(t)('components.transaction.none')), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('components.transaction.id')) + " " + _toDisplayString(_unref(walletTransaction)?.transaction.order?.nanoid || _unref(t)('components.transaction.none')), 1)
            ]),
            (_unref(walletTransaction)?.transaction.order?.location_name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)('components.transaction.location_name')) + " " + _toDisplayString(_unref(walletTransaction)?.transaction.order?.location_name), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(walletTransaction)?.overview.invoicing.company), 1),
            _createElementVNode("div", _hoisted_12, [
              (_unref(walletTransaction)?.overview.invoicing.vat_id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(t)('components.transaction.vat')) + ": " + _toDisplayString(_unref(walletTransaction)?.overview.invoicing.vat_id), 1))
                : _createCommentVNode("", true),
              (_unref(walletTransaction)?.overview.invoicing.address.street && _unref(walletTransaction)?.overview.invoicing.address.number && _unref(walletTransaction)?.overview.invoicing.address.postal_code && _unref(walletTransaction)?.overview.invoicing.address.city)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(walletTransaction)?.overview.invoicing.address.street) + " " + _toDisplayString(_unref(walletTransaction)?.overview.invoicing.address.number) + ", " + _toDisplayString(_unref(walletTransaction)?.overview.invoicing.address.postal_code) + " " + _toDisplayString(_unref(walletTransaction)?.overview.invoicing.address.city), 1))
                : _createCommentVNode("", true)
            ]),
            (_unref(walletTransaction)?.transaction.type !== 'top_up_cost')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(walletTransaction)?.overview.items, (transactionOverviewItem, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "flex justify-between"
                    }, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(transactionOverviewItem.quantity) + "x " + _toDisplayString(transactionOverviewItem.label), 1),
                      (transactionOverviewItem.price !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("span", null, _toDisplayString(isCurrencyPrice(transactionOverviewItem) || _unref(walletTransaction)?.transaction.type === 'top_up' ? transactionOverviewItem.currency?.prefix : _unref(fiatCurrency).prefix) + " " + _toDisplayString(_unref(walletTransaction)?.transaction.type === 'top_up' ? _unref(convertToCurrency)((transactionOverviewItem.quantity * +transactionOverviewItem.price) / (transactionOverviewItem.currency?.exchange_rate || 1)) : _unref(convertToCurrency)(transactionOverviewItem.quantity * +transactionOverviewItem.price)) + " " + _toDisplayString(_unref(walletTransaction)?.transaction.type === 'top_up' ? transactionOverviewItem.currency?.suffix : ''), 1),
                            (transactionOverviewItem.vat_percent)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(transactionOverviewItem.vat_percent) + "% ", 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_unref(walletTransaction)?.transaction.type === 'top_up_cost')
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(walletTransaction)?.overview.items, (transactionOverviewItem, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "flex justify-between"
                    }, [
                      _createElementVNode("div", _hoisted_20, [
                        _createTextVNode(" 1x " + _toDisplayString(_unref(t)('components.transaction.type.top_up_cost')) + " ", 1),
                        _createElementVNode("span", null, " (" + _toDisplayString(_unref(fiatCurrency).prefix) + " " + _toDisplayString(_unref(convertToCurrency)(+_unref(walletTransaction)?.transaction?.amount)) + ") ", 1)
                      ]),
                      (transactionOverviewItem.price !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            (_unref(walletTransaction)?.transaction?.vat_percentage)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_unref(walletTransaction)?.transaction.vat_percentage) + "% ", 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_unref(walletTransaction)?.overview && _unref(walletTransaction)?.overview.vat_items.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(walletTransaction)?.overview.vat_items, (transactionVatOverviewItem, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "flex justify-between"
                    }, [
                      _createElementVNode("div", _hoisted_24, [
                        _createTextVNode(_toDisplayString(_unref(t)('components.transaction.vat')) + " " + _toDisplayString(transactionVatOverviewItem.label) + " ", 1),
                        _createElementVNode("span", null, " (" + _toDisplayString(transactionVatOverviewItem?.currency?.prefix ?? _unref(fiatCurrency).prefix) + " " + _toDisplayString(_unref(convertToCurrency)(transactionVatOverviewItem.price)) + ") ", 1)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "h-px bg-white/20 border-0" }, null, -1)),
          _createElementVNode("div", _hoisted_25, [
            (_unref(walletTransaction)?.transaction.type !== 'top_up_cost')
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupAndSumTransactionsByCurrency)(
						// For split payments, only show transactions for this wallet
						_unref(walletTransaction)?.transaction.is_split_payment ? (_unref(walletTransaction)?.overview.transactions || []).filter((t) => t.wallet_id === _unref(walletTransaction).transaction.wallet_id) : _unref(walletTransaction)?.overview.transactions,
					), (transactionGroup, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "flex justify-between"
                    }, [
                      (transactionGroup.type === 'payment')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_unref(t)('components.transaction_detail.transaction_types.payment')), 1))
                        : _createCommentVNode("", true),
                      (transactionGroup.type === 'refund_transaction_cost')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_unref(t)('components.transaction_detail.transaction_types.refund_transaction_cost')), 1))
                        : _createCommentVNode("", true),
                      (transactionGroup.type === 'top_up')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(t)('components.transaction.type.top_up')), 1))
                        : _createCommentVNode("", true),
                      (transactionGroup.type === 'refund_holding')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_unref(t)('components.transaction.type.refund_holding')), 1))
                        : _createCommentVNode("", true),
                      (transactionGroup.type === 'event_ticket_purchase')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_unref(t)('components.transaction.type.event_ticket_purchase')), 1))
                        : _createCommentVNode("", true),
                      (transactionGroup.type === 'warranty_products_return')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_unref(t)('components.transaction.type.warranty_products_return')), 1))
                        : _createCommentVNode("", true),
                      (transactionGroup.type === 'products_purchased')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_unref(t)('components.transaction.type.products_purchased')), 1))
                        : _createCommentVNode("", true),
                      (transactionGroup.type === 'web_shop_products_purchased')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_unref(t)('components.transaction.type.web_shop_products_purchased')), 1))
                        : _createCommentVNode("", true),
                      (transactionGroup.type === 'rfid_card_creation_cost')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_unref(t)('wallet.rfid_activation_cost')), 1))
                        : _createCommentVNode("", true),
                      (transactionGroup.type === 'refunded_amount')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_unref(t)('components.transaction_detail.transaction_types.refund')), 1))
                        : _createCommentVNode("", true),
                      (transactionGroup.type !== 'top_up_cost')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _createElementVNode("span", null, _toDisplayString(transactionGroup?.prefix) + " " + _toDisplayString(_unref(convertToCurrency)(+transactionGroup?.totalAmount)), 1),
                            _cache[0] || (_cache[0] = _createTextVNode()),
                            (transactionGroup.totalFiatAmount !== transactionGroup.totalAmount)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_38, "(€ " + _toDisplayString(_unref(convertToCurrency)(+transactionGroup.totalFiatAmount)) + ")", 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(t)('components.transaction_detail.transaction_types.top_up_cost')), 1),
                    _createElementVNode("div", _hoisted_42, [
                      (_unref(walletTransaction).transaction.type === 'top_up_cost')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_43, " - " + _toDisplayString(_unref(fiatCurrency).prefix) + " " + _toDisplayString(_unref(convertToCurrency)(+paidTransactionCostPrice())), 1))
                        : _createCommentVNode("", true),
                      (_unref(walletTransaction).transaction.type !== 'top_up_cost')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_unref(walletTransaction).transaction.currency.prefix) + " " + _toDisplayString(_unref(convertToCurrency)(paidTransactionCostPrice())), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("span", _hoisted_46, _toDisplayString(_unref(t)('components.transaction_detail.total_label')), 1),
              (_unref(walletTransaction)?.transaction.type === 'top_up')
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("span", _hoisted_48, _toDisplayString(_unref(fiatCurrency).prefix) + " " + _toDisplayString(_unref(convertToCurrency)(+walletTransactionTotalFiat.value)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_unref(walletTransaction)?.transaction.type !== 'top_up')
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    (_unref(walletTransaction)?.transaction.type !== 'top_up_cost')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                          (_unref(walletTransaction)?.transaction?.order)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                                _createTextVNode(_toDisplayString(_unref(walletTransaction)?.transaction?.currency?.prefix) + " " + _toDisplayString(_unref(convertToCurrency)(_unref(walletTransaction).transaction.direction === 'DEBIT' ? +walletTransactionTotal.value * -1 : +walletTransactionTotal.value)) + " ", 1),
                                (_unref(walletTransaction)?.transaction?.currency?.exchange_rate !== 1)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_52, " (" + _toDisplayString(_unref(fiatCurrency).prefix) + _toDisplayString(_unref(convertToCurrency)(_unref(walletTransaction).transaction.direction === 'DEBIT' ? +walletTransactionTotalFiat.value * -1 : +walletTransactionTotalFiat.value)) + ") ", 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_unref(fiatCurrency).prefix) + _toDisplayString(_unref(convertToCurrency)(+walletTransactionTotalFiat.value)), 1))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_unref(walletTransaction)?.transaction.type === 'top_up_cost')
                ? (_openBlock(), _createElementBlock("span", _hoisted_54, " - " + _toDisplayString(_unref(fiatCurrency).prefix) + " " + _toDisplayString(_unref(convertToCurrency)(+_unref(walletTransaction)?.transaction.amount)), 1))
                : _createCommentVNode("", true)
            ]),
            (_unref(walletTransaction)?.transaction.is_split_payment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("span", _hoisted_57, _toDisplayString(_unref(t)('components.transaction_detail.split_payment_details')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("span", _hoisted_59, _toDisplayString(_unref(t)('components.transaction_detail.total_order_amount')), 1),
                    _createElementVNode("span", _hoisted_60, [
                      _createTextVNode(_toDisplayString(_unref(walletTransaction)?.transaction?.currency?.prefix) + " " + _toDisplayString(_unref(convertToCurrency)(+_unref(walletTransaction).transaction.total_order_price / (_unref(walletTransaction)?.transaction?.currency?.exchange_rate ?? 1))) + " ", 1),
                      (_unref(walletTransaction)?.transaction?.currency?.exchange_rate !== 1)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_61, " (" + _toDisplayString(_unref(fiatCurrency).prefix) + " " + _toDisplayString(_unref(convertToCurrency)(+_unref(walletTransaction).transaction.total_order_price)) + ") ", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("span", _hoisted_63, _toDisplayString(_unref(t)('components.transaction_detail.wallet_portion')), 1),
                    _createElementVNode("span", _hoisted_64, [
                      _createTextVNode(_toDisplayString(_unref(walletTransaction)?.transaction?.currency?.prefix) + " " + _toDisplayString(_unref(convertToCurrency)(Math.abs(+walletTransactionTotal.value))) + " ", 1),
                      (_unref(walletTransaction)?.transaction?.currency?.exchange_rate !== 1)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_65, " (" + _toDisplayString(_unref(fiatCurrency).prefix) + _toDisplayString(_unref(convertToCurrency)(Math.abs(+walletTransactionTotalFiat.value))) + ") ", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_unref(walletTransaction).transaction.split_payment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                        _createElementVNode("div", _hoisted_67, _toDisplayString(_unref(t)('components.transaction_detail.payment_methods_used')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(walletTransaction).transaction.split_payment.payment_methods, (method, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `method-${index}`,
                            class: "flex justify-between items-center mb-1"
                          }, [
                            _createElementVNode("div", _hoisted_68, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-2 h-2 rounded-full mr-2", method.type === 'rfid' ? 'bg-orange-400' : 'bg-green-400'])
                              }, null, 2),
                              _createElementVNode("span", _hoisted_69, _toDisplayString(method.type === 'rfid' ? _unref(t)('components.transaction_detail.payment_method_rfid') : _unref(t)('components.transaction_detail.payment_method_' + method.type)), 1)
                            ]),
                            _createElementVNode("span", _hoisted_70, [
                              (method.amount)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_71, _toDisplayString(method.type === 'rfid' ? _unref(walletTransaction)?.transaction?.currency?.prefix : _unref(fiatCurrency).prefix) + " " + _toDisplayString(method.amount_formatted || _unref(convertToCurrency)(method.amount)), 1))
                                : (method.wallet_id)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_72, " Wallet " + _toDisplayString(method.wallet_id), 1))
                                  : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_unref(walletTransaction)?.transaction.type === 'refund_holding' && _unref(walletTransaction)?.transaction.refund_request)
              ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("span", _hoisted_75, _toDisplayString(_unref(t)('components.transaction_detail.refund_details')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("span", _hoisted_77, _toDisplayString(_unref(t)('components.transaction_detail.total_requested')), 1),
                    _createElementVNode("span", _hoisted_78, _toDisplayString(_unref(fiatCurrency).prefix) + " " + _toDisplayString(_unref(convertToCurrency)(Math.abs(+_unref(walletTransaction).transaction.refund_request.fiat_amount))), 1)
                  ]),
                  (_unref(walletTransaction).transaction.refund_request.include_transaction_cost && _unref(walletTransaction).transaction.refund_request.transaction_cost)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                        _createElementVNode("span", _hoisted_80, _toDisplayString(_unref(t)('components.transaction_detail.refund_cost')), 1),
                        _createElementVNode("span", _hoisted_81, " - " + _toDisplayString(_unref(fiatCurrency).prefix) + " " + _toDisplayString(_unref(convertToCurrency)(+_unref(walletTransaction).transaction.refund_request.transaction_cost)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("span", _hoisted_83, _toDisplayString(_unref(t)('components.transaction_detail.total_refunded')), 1),
                    _createElementVNode("span", _hoisted_84, _toDisplayString(_unref(fiatCurrency).prefix) + " " + _toDisplayString(_unref(convertToCurrency)(Math.abs(+_unref(walletTransaction).transaction.refund_request.fiat_amount) - (_unref(walletTransaction).transaction.refund_request.include_transaction_cost ? +_unref(walletTransaction).transaction.refund_request.transaction_cost || 0 : 0))), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("span", _hoisted_86, _toDisplayString(_unref(t)('components.transaction_detail.payment_method')), 1),
              _createElementVNode("span", _hoisted_87, [
                (_unref(walletTransaction)?.transaction.is_split_payment)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_88, " Split Payment "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_89, _toDisplayString(_unref(t)(paymentMethodTranslationKey())), 1))
              ])
            ]),
            (_unref(walletTransaction)?.overview?.payment_method === 'wire_transfer')
              ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                  _createElementVNode("span", _hoisted_91, _toDisplayString(_unref(t)('components.transaction_detail.refund_wire_transfer_period')), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(walletTransaction)?.overview.status !== 'no-order')
              ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                  _createElementVNode("span", _hoisted_93, _toDisplayString(_unref(t)('components.transaction_detail.payment_status')), 1),
                  _createElementVNode("span", _hoisted_94, _toDisplayString(_unref(walletTransaction)?.overview.status), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})